export default {
    data () {
        return {
            progress_ko: {
                eco_vadis: '에',
                requested: '신',
                completed: '완',
                in_assessment: '평',
                in_reprogress: '보',
                in_progress: '답',
                canceled: '취'
            },
            progress_bg: {
                '에': 'secondary',
                '미': 'warning',
                '신': 'green',
                '완': 'black-medium',
                '평': 'red',
                '답': 'blue-basic',
                '보': 'blue-dark',
                '취': 'red5'
            },
            status_sort_order: {
                not_requested: 0,
                requested: 1,
                in_progress: 2,
                in_assessment: 3,
                in_reprogress: 4,
                completed: 5,
                eco_vadis: 6
            },
            status_sort_order_ko: {
                '미': 0,
                '신': 1,
                '평': 2,
                '답': 3,
                '보': 4,
                '완': 5,
                '취': 6,
                '에': 7
            }
        };
    },
    computed: {},
    created () {},
    mounted () {},
    methods: {
        getProgressStatus(company){
            const _status_code = company.status_code;
            const _manual_status = company.manual_status;
            
            if (_manual_status === 'eco_vadis') {
                return '에';
            } else if (_status_code === 'in_progress') {
                const _in_assessment_ts = !company.priority
                    ? company.in_assessment_ts
                    : company.priority.in_assessment_ts;

                if(_in_assessment_ts && _in_assessment_ts !== null) {
                    return '보';
                } else {
                    return '답';
                }
            } else if (this.progress_ko[_status_code]) {
                return this.progress_ko[_status_code];
            } else {
                return '미';
            }
        },
        getProgressColor (company) {
            const _status_code = this.getProgressStatus(company);
            return this.progress_bg[_status_code];
        },
        sortingCompanies(_companies, opt = {}) {
            if (!_companies || !_companies.length) {
                return [];
            } else {
                let _sorted__companies = _companies.sort((a, b) => {
                    const _a_status_order = this.status_sort_order_ko[this.getProgressStatus(a.priority ? a.priority : a)];
                    const _b_status_order = this.status_sort_order_ko[this.getProgressStatus(b.priority ? b.priority : b)];
                    return _a_status_order - _b_status_order;
                });

                if (!opt.data) {
                    return _sorted__companies;    
                }

                return _sorted__companies.map(_data => ({ ..._data, ...opt.data }));
            }
        }
    }
};
